export { getLegalDocsData } from './get-legal-docs-data';
export { useDocsList } from './use-doc-list';
